import { ChiroUpAPI } from '@chiroup/client-core/functions/ChiroUpAPI';
import {
  CrossoverRepairApplyRequest,
  CrossoverRepairApplyResponse,
  CrossoverRepairClinicsRequest,
  CrossoverRepairClinicsResponse,
  CrossoverRepairPreview,
  CrossoverRepairPreviewRequest,
  CrossoverRepairScanRequest,
  CrossoverRepairScanResponse,
} from '@chiroup/core/types/CrossoverRepair.type';

export const listCrossoverClinics = (
  body: CrossoverRepairClinicsRequest
): Promise<CrossoverRepairClinicsResponse> =>
  ChiroUpAPI.post('api', '/devtools/crossover-repair', { body });

export const scanCrossovers = (
  body: CrossoverRepairScanRequest
): Promise<CrossoverRepairScanResponse> =>
  ChiroUpAPI.post('api', '/devtools/crossover-repair', { body });

export const previewCrossover = (
  body: CrossoverRepairPreviewRequest
): Promise<CrossoverRepairPreview> =>
  ChiroUpAPI.post('api', '/devtools/crossover-repair', { body });

export const applyCrossover = (
  body: CrossoverRepairApplyRequest
): Promise<CrossoverRepairApplyResponse> =>
  ChiroUpAPI.post('api', '/devtools/crossover-repair', { body });
